import { createBrowserHistory } from 'history'
import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import status from './status'
import { user } from './user'
import { users } from './users'
import { USER } from '../types'
import userPermissions from './permissions'
import userSetups from './userSetups'
import { setups } from './setups'
import setup from './setup'
import metrics from './metrics'
import qm from './setupThreshold'
import report from './report'
import powerCurve from './powerCurve'

const createRootReducer = (state, action) => {
  if (action.type === USER.LOGOUT) {
    const { router } = state
    state = { router }
  }
  return appReducer(state, action)
}

export const history = createBrowserHistory()

// Add previous-path tracking here
let previousPath = null
let currentPath = history.location.pathname

history.listen(location => {
  previousPath = currentPath
  currentPath = location.pathname
})

// Export getter for components
export const getPreviousPath = () => previousPath

const appReducer = combineReducers({
  router: connectRouter(history),
  status,
  user,
  users,
  userPermissions,
  userSetups,
  setups,
  setup,
  metrics,
  qm,
  report,
  powerCurve,
})

export default createRootReducer
